import * as Types from './mutation-types'
import {
  API_STATES
} from '@/helpers'

const mutations = {
  [Types.GET_PERMISSIONS_BEGIN](state) {
    state.permissionsGetState = API_STATES.REQUEST_PENDING
  },
  [Types.GET_PERMISSIONS_SUCCESS](state, permissions) {
    state.permissionsGetError = null
    state.permissions = permissions
    state.permissionsGetState = API_STATES.REQUEST_SUCCESS
  },
  [Types.GET_PERMISSIONS_ERROR](state, err) {
    state.permissionsGetState = API_STATES.REQUEST_ERROR
    state.permissionsGetError = err
  },

  [Types.GET_ASSIGNED_PERMISSIONS_BEGIN](state) {
    state.assignedPermissionsGetState = API_STATES.REQUEST_PENDING
  },
  [Types.GET_ASSIGNED_PERMISSIONS_SUCCESS](state, assignedPermissions) {
    state.assignedPermissionsGetError = null
    state.assignedPermissions = assignedPermissions
    state.assignedPermissionsGetState = API_STATES.REQUEST_SUCCESS
  },
  [Types.GET_ASSIGNED_PERMISSIONS_ERROR](state, err) {
    state.assignedPermissionsGetState = API_STATES.REQUEST_ERROR
    state.assignedPermissionsGetError = err
  },

  [Types.ASSIGN_PERMISSION_BEGIN](state) {
    state.permissionsCreateState = API_STATES.REQUEST_PENDING
  },
  [Types.ASSIGN_PERMISSION_SUCCESS](state) {
    state.permissionsCreateError = null
    state.permissionsCreateState = API_STATES.REQUEST_SUCCESS
  },
  [Types.ASSIGN_PERMISSION_ERROR](state, err) {
    state.permissionsCreateState = API_STATES.REQUEST_ERROR
    state.permissionsCreateError = err
  },

  [Types.UNASSIGN_PERMISSION_BEGIN](state) {
    state.permissionsDeleteState = API_STATES.REQUEST_PENDING
  },
  [Types.UNASSIGN_PERMISSION_SUCCESS](state) {
    state.permissionsDeleteError = null
    state.assignedPermissions = []
    state.permissionsDeleteState = API_STATES.REQUEST_SUCCESS
  },
  [Types.UNASSIGN_PERMISSION_ERROR](state, err) {
    state.permissionsDeleteState = API_STATES.REQUEST_ERROR
    state.permissionsDeleteError = err
  }
}

export default mutations
